import { render, staticRenderFns } from "./setPhoneLogin.vue?vue&type=template&id=01a86898&"
import script from "./setPhoneLogin.vue?vue&type=script&lang=js&"
export * from "./setPhoneLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports